import { useFavoriteExhibitorIds } from "hooks/useFavoriteExhibitorIds"
import { useUser } from "hooks/useUser"
import ConventionVideo from "models/convention-api/v1/ConventionVideo"

export const useFavoriteVideosPages = () => {
  const user = useUser()
  const favoriteExhibitorIds = useFavoriteExhibitorIds()

  const videos = ConventionVideo.useMore(() => {
    if (!user) return null
    if (!favoriteExhibitorIds) return null
    if (favoriteExhibitorIds.length === 0) return null

    return {
      limit: 20,
      sort: "-created_at",
      filter: {
        favorite_exhibitors: favoriteExhibitorIds,
      },
      includes: ["institution", "video_count"],
    }
  })

  const getIsReady = () => {
    // user is not logged in
    if (!user) return true

    // check if favoriteExhibitorIds data is ready
    if (favoriteExhibitorIds && favoriteExhibitorIds.length === 0) return true

    // wait till some videos data is loaded
    return !!videos.data
  }

  return {
    isReady: getIsReady(),
    videos: videos.data ?? [],
    loadMore: videos.loadMore,
    hasMore: videos.hasMore,
    isValidating: videos.isLoading || !favoriteExhibitorIds,
  }
}
